import ApiClient from "../helpers/ApiClient";


export const addData = async ({ sport_activity, description, file }) => {
    try {
        const response = await ApiClient.post(`/researchandstudentlife/addSports`,
            
            { sport_activity, description, file },
            
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response add", response);
        return response;
    } catch (error) {
        throw error;
    }
}

export const getData = async () => {
    try {
        const response = await ApiClient.get(`/researchandstudentlife/getSports`);
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const editData = async ({ id, sport_activity, description, file }) => {

    try {
        const response = await ApiClient.put(`/researchandstudentlife/updateSports/${id}`,
            { sport_activity, description, file  },
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
        console.log("response", response);
        return response;
    } catch (error) {
        throw error;
    }
}


export const deleteData = async ({ id }) => {
    try {
        const response = await ApiClient.delete(`/researchandstudentlife/deleteSports/${id}`);
        console.log("response delete", response);
        return response;
    } catch (error) {
        throw error;
    }
}